import type { LinkBreadcrumbItem } from '@shared/ui/menus'

import { AppRoute } from '@shared/config'

interface TaskCreationHeaderReturn {
  config: ComputedRef<LinkBreadcrumbItem[]>
}

export const useTaskCreationHeader = (): TaskCreationHeaderReturn => {
  const config = computed(() => [
    {
      id: 'tasks-kanban',
      text: 'Tasks Kanban',
      to: AppRoute.TasksKanbanSupport,
      disabled: false,
    },
    {
      id: 'new-task',
      text: 'Create new task',
      to: AppRoute.TasksKanbanSupport,
      disabled: true,
    },
  ])

  return {
    config,
  }
}
